/**
 * Утилиты файлов Диска (клиент).
 * Резолвер URL файла живёт уровнем выше — `client/fileUrl.ts` (нужен не только Диску).
 */

/** Файл — изображение (для превью в плитке вместо иконки типа). */
export function isImageMime(mimeType: string | null | undefined): boolean {
  return typeof mimeType === 'string' && mimeType.startsWith('image/');
}

/** Размер файла в человекочитаемом виде. */
export function formatFileSize(bytes: number | null | undefined): string {
  if (!bytes) return '—';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
}
